import React from "react";
import { Flag, Plus, Trash2, Link2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { GrowInput } from "@/components/ui/grow-input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const KPI_LABEL = { likes: "الإعجابات", comments: "التعليقات", reposts: "المشاركات" };

export function KeyResultsCard({ items, onChange }) {
  const update = (i, field, val) => {
    const next = [...items];
    next[i] = { ...next[i], [field]: val };
    onChange(next);
  };
  const add = () => onChange([...items, { label: "", target: 0, unit: "", due: "نهاية الدورة الشهرية", linked_kpi: "", why: "" }]);
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));

  return (
    <div className="glass rounded-2xl p-6 border border-border" data-testid="goals-key-results">
      <div className="flex items-center justify-between mb-3">
        <Label className="font-bold flex items-center gap-2"><Flag className="w-4 h-4 text-accent" /> النتائج الرئيسية (Key Results) — كيف نعرف أننا وصلنا؟</Label>
        {items.length < 3 && (
          <Button type="button" size="sm" variant="outline" onClick={add} className="gap-1" data-testid="kr-add-btn"><Plus className="w-3.5 h-3.5" /> نتيجة</Button>
        )}
      </div>
      <div className="space-y-3">
        {items.map((kr, i) => (
          <div key={i} className="rounded-xl border border-border bg-secondary/50 p-4 space-y-2" data-testid={`kr-card-${i}`}>
            <div className="flex items-start gap-2">
              <span className="mt-2 w-6 h-6 rounded-full bg-accent/15 text-accent text-xs font-bold flex items-center justify-center shrink-0">KR{i + 1}</span>
              <GrowInput value={kr.label} onChange={(e) => update(i, "label", e.target.value)} placeholder="نتيجة قابلة للتحقق، مثال: 50 عميلاً محتملاً عبر الرسائل" className="bg-background border-border" data-testid={`kr-label-${i}`} />
              <Button type="button" size="icon" variant="ghost" onClick={() => remove(i)} className="text-muted-foreground hover:text-destructive shrink-0" data-testid={`kr-remove-${i}`}><Trash2 className="w-4 h-4" /></Button>
            </div>
            <div className="flex flex-wrap gap-2 ps-8">
              <Input type="number" dir="ltr" value={kr.target} onChange={(e) => update(i, "target", e.target.value)} className="bg-background border-border font-bold w-24 shrink-0" data-testid={`kr-target-${i}`} />
              <GrowInput value={kr.unit} onChange={(e) => update(i, "unit", e.target.value)} placeholder="الوحدة" className="bg-background border-border flex-1 min-w-[8rem]" data-testid={`kr-unit-${i}`} />
              <GrowInput value={kr.due} onChange={(e) => update(i, "due", e.target.value)} placeholder="المدة" className="bg-background border-border flex-1 min-w-[8rem]" data-testid={`kr-due-${i}`} />
            </div>
            {(kr.linked_kpi || kr.why) && (
              <p className="text-xs text-muted-foreground ps-8 leading-relaxed">
                {kr.linked_kpi && <span className="inline-flex items-center gap-1 me-2 text-primary"><Link2 className="w-3 h-3" /> يُقاس عبر مؤشر {KPI_LABEL[kr.linked_kpi] || kr.linked_kpi}</span>}
                {kr.why}
              </p>
            )}
          </div>
        ))}
        {!items.length && <p className="text-sm text-muted-foreground">أضف نتيجة رئيسية واحدة على الأقل لتصبح أهدافك قابلة للتحقق.</p>}
      </div>
    </div>
  );
}
